import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import {
  doc,
  getDoc,
  getDocs,
  collection,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "@/firebase";
import { mapState } from "vuex";
import { DateTime } from "luxon";

export const post = {
  data() {
    return {
      prompt: "",
    };
  },
  methods: {
    async duplicatePost() {
      console.log("duplicating post");
      this.saving = true;
      this.thinking = true;
      this.$store.commit("setLoading", { type: "agent", val: true });
      let post = {
        auto_variation: true,
        auto_variation_level: "medium",
        category: this.category ? this.category.uid : null,
        created: Math.floor(Date.now() / 1000),
        created_by: this.userProfile.uid,
        created_by_email: this.userProfile.email,
        recurring: this.recurring,
        last_publish: null,
        scheduled: false,
        schedule_date: null,
        status: "draft",
        media: this.media,
        comment: this.comment,
        workspace: this.userProfile.workspace,
        variations: this.variations,
        uid: null,
        timezone: this.workspace.timezone,
        carousel: this.carousel || null,
      };
      console.log("Adding post");
      const addPost = httpsCallable(functions, "postAdd");
      const result = await addPost(post);
      console.log("Post added", result.data);
      this.sheet = false;

      this.saving = false;
      this.thinking = false;
      this.$store.dispatch("fetchPosts");
      this.$store.commit("setNotification", {
        show: true,
        text: "Your post has been added!",
        type: "primary",
      });
      this.$store.commit("setLoading", { type: "agent", val: false });

      this.loadPost(result.data);
    },
    changeScheduleDate(date) {
      console.log(date);
      // Date picked in the calendar (usually with time 00:00)
      const picked = DateTime.fromJSDate(date).setZone(this.workspace.timezone);

      // Base time: existing schedule_date (keeps its time) or "now" if none
      let base = this.schedule_date
        ? DateTime.fromSeconds(this.schedule_date).setZone(
            this.workspace.timezone,
          )
        : DateTime.now().setZone(this.workspace.timezone);

      // Only replace the calendar part (Y-M-D), keep time fields
      base = base.set({
        year: picked.year,
        month: picked.month,
        day: picked.day,
      });

      const scheduled = Math.floor(base.toSeconds());
      console.log(scheduled);
      this.schedule_date = scheduled;
    },
    async keepPost() {
      await updateDoc(
        doc(db, "workspaces", this.userProfile.workspace, "posts", this.post),
        {
          status: "draft",
        },
      );
      this.savePost(this.schedule_date, "draft");
      this.$store.dispatch("fetchPosts");
      this.status = "draft";
    },
    async rejectPost() {
      let r = window.confirm("Are you sure to discard this post?");

      if (!r) {
        return;
      }
      // get all variations and delete them
      const variations = await getDocs(
        collection(
          db,
          "workspaces",
          this.userProfile.workspace,
          "posts",
          this.post,
          "variations",
        ),
      );
      variations.docs.forEach(async (v) => {
        await deleteDoc(
          doc(
            db,
            "workspaces",
            this.userProfile.workspace,
            "posts",
            this.post,
            "variations",
            v.id,
          ),
        );
      });
      await deleteDoc(
        doc(db, "workspaces", this.userProfile.workspace, "posts", this.post),
      );
      this.sheet = false;
      this.$store.commit("setNotification", {
        show: true,
        text: "Your post has been rejected!",
        type: "primary",
      });
      this.$store.dispatch("fetchPosts");
      this.$router.push("/library");
    },
    checkPost() {
      return new Promise((resolve) => {
        let complete = {
          pass: true,
          missing: [],
        };

        if (!this.category) {
          complete.pass = false;
          complete.missing.push("Please select a category");
        }
        if (this.recurring === null) {
          complete.pass = false;
          complete.missing.push("Please select if this post can be recurring.");
        }
        if (
          !this.media &&
          this.selected_accounts.find((a) => a.type === "instagram") !=
            undefined
        ) {
          complete.pass = false;
          complete.missing.push(
            "Please add an image. Instagram posts require an image, or remove the Instagram accounts from the list.",
          );
        }

        this.complete = complete;

        resolve(complete);
      });
    },
    async savePost(date, status) {
      console.log("Saving post", date, status);

      const complete = await this.checkPost();
      const now = DateTime.now().setZone(this.workspace.timezone);
      console.log("Complete", complete);
      if (!complete.pass && status != "draft") {
        this.$store.commit("setNotification", {
          show: true,
          text: complete.missing.join("\n"),
          type: "error",
        });
        return;
      }

      this.saving = true;
      this.thinking = true;
      this.$store.commit("setLoading", { type: "agent", val: true });
      let pdf = null;
      // Get HTML from Claude-generated HTML carousel if active
      const htmlCarousel = this.$store.state.post.carousel;
      const isHtmlCarousel =
        htmlCarousel?.length > 0 && htmlCarousel[0]?.slide_html;
      if (isHtmlCarousel) {
        const slidesHTML = htmlCarousel.map((s) => s.slide_html);
        const generatePDF = httpsCallable(functions, "generatePDF");
        this.generatingPDF = true;
        const res = await generatePDF({
          htmlPages: slidesHTML,
          uid: this.$store.state.post.post,
          workspace: this.$store.state.workspace.workspace.uid,
        });
        pdf = res.data.pdf;
        if (!this.media[0]) {
          this.media = [{}];
        }
        this.media[0].src = res.data.pdf;
        this.media[0].extension = "pdf";
        this.media[0].type = "carousel";
        this.generatingPDF = false;
      }
      // Get HTML from template carousel if active
      else if (this.media?.[0]?.type === "carousel") {
        const getPDFFn = this.$store.state.post.getPDFFn;

        let slidesHTML = this.carousel.map((slide) => {
          return getPDFFn(slide);
        });

        const generatePDF = httpsCallable(functions, "generatePDF");
        this.generatingPDF = true;
        const res = await generatePDF({
          htmlPages: slidesHTML,
          uid: this.$store.state.post.post,
          workspace: this.$store.state.workspace.workspace.uid,
        });
        pdf = res.data.pdf;
        this.media[0].src = res.data.pdf;
        this.media[0].extension = "pdf";
      }

      try {
        const getHTMLFn = this.$store.state.post.getHTMLFn;
        if (getHTMLFn && this.media[0]?.type === "template") {
          const html = getHTMLFn();
          this.$store.commit("setPostHTML", html);
          console.log("Got HTML from imageBuilder:", html);
          const htmlToImage = httpsCallable(functions, "htmlToImage");
          const result = await htmlToImage({
            html: html,
            uid: this.post,
            workspace: this.userProfile.workspace,
          });
          console.log("HTML to image result:", result.data);
          this.media[0].src = result.data.downloadURL;
        }
        if (this.media[0]?.extension === "html") {
          const htmlToImage = httpsCallable(functions, "htmlToImage");
          const result = await htmlToImage({
            html: this.media[0].html,
            uid: this.post,
            workspace: this.userProfile.workspace,
          });
          console.log("HTML to image result:", result.data);
          this.media[0].src = result.data.downloadURL;
        }

        if (date === "now") {
          date = DateTime.now().toSeconds();
        }

        // Check if date is in the past
        if (date && typeof date === "number") {
          const dateTime = DateTime.fromSeconds(date).setZone(
            this.workspace.timezone,
          );

          if (dateTime < now && date !== "now" && status !== "draft") {
            this.$store.commit("setNotification", {
              show: true,
              text: "Cannot schedule a post in the past. Please select a future date.",
              type: "error",
            });
            return;
          }
        }

        if (status === "draft" && date) {
          date = null;
        }

        let post = {
          auto_variation: this.auto_variation || true,
          auto_variation_level: this.auto_variation_level || "medium",
          category: this.category ? this.category.uid : null,
          created: Math.floor(Date.now() / 1000),
          created_by: this.userProfile.uid,
          created_by_email: this.userProfile.email,
          carousel_pdf: pdf,
          carousel: this.$store.state.post.carousel || [],
          recurring: this.recurring,
          last_publish: null,
          scheduled: date != null,
          schedule_date: date ? date : null,
          status: status,
          media: this.media,
          comment: this.comment,
          workspace: this.userProfile.workspace,
          variations: this.variations,
          uid: this.post ? this.post : null,
          timezone: this.workspace.timezone,
        };
        console.log("Post", post);
        if (this.post) {
          // IF EXISTING POST, THEN UPDATE THE POST
          console.log("Updating post");
          const updatePost = httpsCallable(functions, "postUpdate");
          await updatePost(post);
          this.saving = false;
          this.$store.dispatch("refreshPost", this.post);

          this.$store.commit("setNotification", {
            show: true,
            text: "Your post has been updated!",
            type: "primary",
          });
        } else {
          // IF NEW POST, ADD POST TO DB
          console.log("Adding post");
          const addPost = httpsCallable(functions, "postAdd");
          await addPost(post);
          this.saving = false;
          this.thinking = false;
          this.$store.dispatch("fetchPosts");
          this.$store.commit("setNotification", {
            show: true,
            text: "Your post has been added!",
            type: "primary",
          });
        }
      } catch (error) {
        console.log(error);
        this.$store.commit("setNotification", {
          show: true,
          text: "Error saving post",
          type: "error",
        });
      }
      this.saved = true;
      this.$store.dispatch("getCalendarDays");
      this.$store.dispatch("fetchMedia");
      this.$store.dispatch("clearPost");
      this.$router.push("/library");
      this.sheet = false;
      this.$store.commit("setLoading", { type: "agent", val: false });
      this.thinking = false;
    },
    async loadPost(uid) {
      console.log("loading post", uid);

      this.$store.dispatch("clearPost");
      this.post = uid;
      const docRef = doc(
        db,
        "workspaces",
        this.userProfile.workspace,
        "posts",
        uid,
      );
      const docSnap = await getDoc(docRef);
      let p = docSnap.data();

      p.variations = [];
      const messages = await getDocs(
        collection(
          db,
          "workspaces",
          this.userProfile.workspace,
          "posts",
          uid,
          "variations",
        ),
      );
      messages.docs.map((d) => {
        p.variations.push({ ...d.data(), undo: [d.data().text], redo: [] });
      });
      this.selected_accounts = [];
      this.category = this.categories.find((c) => c.uid === p.category);
      this.selected_accounts = p.accounts;
      this.$store.commit("setPostStatistics", p.statistics || null);
      if (p.carousel && p.carousel.length > 0 && p.carousel[0]?.slide_html) {
        this.$store.commit("setPostCarousel", p.carousel);
        this.mode = "carousel";
      } else if (p.media[0]?.type === "carousel") {
        this.selectedSlideIndex = 0;
        this.carousel = p.media[0].slides;
        this.mode = "carousel";
      }

      this.last_publish = p.last_publish ? p.last_publish : null;
      this.variations = p.variations;
      this.comment = p.comment;
      if (p.comment) {
        this.show_comment = true;
      }
      this.media = p.media;
      if (this.media[0]?.type === "template") {
        this.selectedTemplate = this.media[0].template;
        this.selectedTemplateOption = this.media[0].option;
        this.selectedTemplateData = this.media[0].data;
        this.mode = "template";
      }
      this.recurring = p.recurring;
      this.auto_variation = p.auto_variation || false;
      this.auto_variation_level = p.auto_variation_level || "medium";
      this.schedule_date = p.schedule_date ? p.schedule_date : null;
      this.status = p.status;
      this.suggested = p.suggested;
      this.$store.commit("setShowChat", false);
      this.changes = false;
      if (this.$route.path === "/library") {
        this.sheet = true;
      }
      this.$store.commit("setPostUrn", p.urn);
    },
    async askAnything(v) {
      console.log(v);

      let timestamp = Date.now();
      this.variations[this.tab].timestamp = timestamp;
      try {
        const anything = httpsCallable(functions, "openaiAskAnything");
        const result = await anything({
          prompt: v,
          text: this.variations[this.tab].text,
        });
        this.$refs.askChat.clear();
        await this.useContent(result.data, timestamp);
      } catch (error) {
        console.log(error);
        this.$store.commit("setNotification", {
          show: true,
          text: "Not enough tokens",
          type: "error",
        });
      }

      this.$store.commit("setLoading", { type: "ai.anything", val: false });
    },
    async generateVariation(level) {
      this.thinking = true;
      if (this.variations[this.tab].text === "") {
        this.$store.commit("setNotification", {
          show: true,
          text: "Input copy can not be empty.",
          type: "error",
        });
      } else {
        this.$store.commit("setLoading", { type: "ai.variation", val: true });
        let timestamp = Date.now();
        this.variations.push({
          text: "",
          type: "variation",
          timestamp: timestamp,
          undo: [""],
          uid: this.variations.length.toString(),
          redo: [],
          media: null,
        });

        let copy = this.variations[this.tab].text;
        // this.tab++;
        const vm = this;
        setTimeout(() => {
          vm.tab = vm.variations.length - 1;
        }, 250);

        try {
          const variation = httpsCallable(functions, "rewritePost");
          const result = await variation({
            brand_voice: this.voice?.description || "",
            original_post: copy,
            level: level,
          });
          await this.useContent(result.data, timestamp);
        } catch (error) {
          console.log(error);
          this.$store.commit("setNotification", {
            show: true,
            text: "Not enough tokens",
            type: "error",
          });
        }

        this.$store.commit("setLoading", { type: "ai.variation", val: false });
      }
      this.thinking = false;
    },
    async linkPost(lang, instructions, content, url) {
      this.$store.commit("setLoading", { type: "ai.generate", val: true });
      let timestamp = Date.now();
      this.variations[this.tab].timestamp = timestamp;
      try {
        const linkPost = httpsCallable(functions, "openaiWriteLinkPost");
        const result = await linkPost({
          instructions: instructions,
          lang: lang,
          content: content,
          url: url,
        });
        await this.useContent(result.data, timestamp);
      } catch (error) {
        console.log(error);
        this.$store.commit("setNotification", {
          show: true,
          text: "Not enough tokens",
          type: "error",
        });
      }

      this.$store.commit("setLoading", { type: "ai.generate", val: false });
    },
    useContent(v, t) {
      return new Promise((resolve) => {
        console.log(v);
        let x = this.variations.find((v) => v.timestamp === t);

        if (!v.includes(" ")) {
          x.text = v;
          resolve();
        } else {
          let chunks = v.split(" ");

          x.text = "";
          for (let i = 0; i <= chunks.length - 1; i++) {
            setTimeout(function () {
              let space = i === 0 ? "" : " ";
              x.text = x.text.concat(space, chunks[i]);
              if (i + 1 === chunks.length) {
                x.timestamp = null;
                resolve();
              }
            }, 25 * i);
          }
        }

        this.ideas_drawer = false;
      });
    },
    async writePost() {
      this.$store.commit("setLoading", { type: "ai.generate", val: true });
      let timestamp = Date.now();
      this.variations[this.tab].timestamp = timestamp;
      const write = httpsCallable(functions, "generatePost");
      let idea = this.idea;
      if (this.media[0]?.type === "url") {
        idea.link = this.media[0].url;
      }
      try {
        const result = await write({
          instructions: this.instructions,
          idea: idea,
          structure: this.structure,
          brand: this.brand,
          voice: this.voice?.description || "",
        });
        await this.useContent(result.data, timestamp);
        this.$refs.askChat.clear();
      } catch (error) {
        console.log(error);
        this.$store.commit("setNotification", {
          show: true,
          text: "Not enough tokens",
          type: "error",
        });
      }

      this.$store.commit("setLoading", { type: "ai.generate", val: false });
    },
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      categories: (state) => state.posts.categories,
    }),
    current_variation() {
      return this.variations[this.tab];
    },
    selectedSlideIndex: {
      get() {
        return this.$store.state.post.selectedSlideIndex;
      },
      set(value) {
        this.$store.commit("setPostSelectedSlideIndex", value);
      },
    },
    template_dialog: {
      get() {
        return this.$store.state.post.template_dialog;
      },
      set(value) {
        this.$store.commit("setPostTemplateDialog", value);
      },
    },
    tab: {
      get() {
        return this.$store.state.post.tab;
      },
      set(value) {
        this.$store.commit("setPostTab", value);
      },
    },
    idea: {
      get() {
        return this.$store.state.post.idea;
      },
      set(value) {
        this.$store.commit("setPostIdea", value);
      },
    },
    voice: {
      get() {
        return this.$store.state.post.voice;
      },
      set(value) {
        this.$store.commit("setPostVoice", value);
      },
    },
    brand: {
      get() {
        return this.$store.state.post.brand;
      },
      set(value) {
        this.$store.commit("setPostBrand", value);
      },
    },
    mode: {
      get() {
        return this.$store.state.post.mode;
      },
      set(value) {
        this.$store.commit("setPostMode", value);
      },
    },
    selectedModel: {
      get() {
        return this.$store.state.post.selected_model;
      },
      set(value) {
        this.$store.commit("setPostSelectedModel", value);
      },
    },
    expand: {
      get() {
        return this.$store.state.post.askChatDrawer;
      },
      set(value) {
        this.$store.commit("setPostAskChatDrawer", value);
      },
    },
    preview_dialog: {
      get() {
        return this.$store.state.post.preview_dialog;
      },
      set(value) {
        this.$store.commit("setPostPreviewDialog", value);
      },
    },
    structure: {
      get() {
        return this.$store.state.post.structure;
      },
      set(value) {
        this.$store.commit("setPostStructure", value);
      },
    },
    carousel: {
      get() {
        return this.$store.state.post.carousel;
      },
      set(val) {
        this.$store.commit("setPostCarousel", val);
      },
    },
    saving: {
      get() {
        return this.$store.state.post.saving;
      },
      set(value) {
        this.$store.commit("setPostSaving", value);
      },
    },
    media: {
      get() {
        return this.$store.state.post.media;
      },
      set(value) {
        this.$store.commit("setPostMedia", value);
      },
    },
    instructions: {
      get() {
        return this.$store.state.post.instructions;
      },
      set(value) {
        this.$store.commit("setPostInstructions", value);
      },
    },
    selectedTemplate: {
      get() {
        return this.$store.state.post.selectedTemplate;
      },
      set(value) {
        this.$store.commit("setPostSelectedTemplate", value);
      },
    },
    selectedTemplateOption: {
      get() {
        return this.$store.state.post.selectedTemplateOption;
      },
      set(value) {
        this.$store.commit("setPostSelectedTemplateOption", value);
      },
    },
    auto_variation: {
      get() {
        return this.$store.state.post.auto_variation;
      },
      set(value) {
        this.$store.commit("setPostAutoVariation", value);
      },
    },
    auto_variation_level: {
      get() {
        return this.$store.state.post.auto_variation_level;
      },
      set(value) {
        this.$store.commit("setPostAutoVariationLevel", value);
      },
    },
    selectedTemplateData: {
      get() {
        return this.$store.state.post.selectedTemplateData;
      },
      set(value) {
        this.$store.commit("setPostSelectedTemplateData", value);
      },
    },
    category: {
      get() {
        return this.$store.state.post.category;
      },
      set(value) {
        this.$store.commit("setPostCategory", value);
      },
    },
    selected_accounts: {
      get() {
        return this.$store.state.post.selected_accounts;
      },
      set(value) {
        this.$store.commit("setPostSelectedAccounts", value);
      },
    },
    comment: {
      get() {
        return this.$store.state.post.comment;
      },
      set(value) {
        this.$store.commit("setPostComment", value);
      },
    },
    dialog: {
      get() {
        return this.$store.state.post.dialog;
      },
      set(value) {
        this.$store.commit("setPostDialog", value);
      },
    },
    show_comment: {
      get() {
        return this.$store.state.post.show_comment;
      },
      set(value) {
        this.$store.commit("setPostShowComment", value);
      },
    },
    urn: {
      get() {
        return this.$store.state.post.urn;
      },
      set(value) {
        this.$store.commit("setPostUrn", value);
      },
    },
    variations: {
      get() {
        return this.$store.state.post.variations;
      },
      set(value) {
        this.$store.commit("setPostVariations", value);
      },
    },
    statistics: {
      get() {
        return this.$store.state.post.statistics;
      },
      set(value) {
        this.$store.commit("setPostStatistics", value);
      },
    },
    recurring: {
      get() {
        return this.$store.state.post.recurring;
      },
      set(value) {
        this.$store.commit("setPostRecurring", value);
      },
    },
    chat: {
      get() {
        return this.$store.state.post.chat;
      },
      set(value) {
        this.$store.commit("setPostChat", value);
      },
    },
    link_preview: {
      get() {
        return this.$store.state.post.link_preview;
      },
      set(value) {
        this.$store.commit("setPostLinkPreview", value);
      },
    },
    post: {
      get() {
        return this.$store.state.post.post;
      },
      set(value) {
        this.$store.commit("setPostUid", value);
      },
    },
    schedule_date: {
      get() {
        return this.$store.state.post.schedule_date;
      },
      set(value) {
        this.$store.commit("setPostScheduleDate", value);
      },
    },
    status: {
      get() {
        return this.$store.state.post.status;
      },
      set(value) {
        this.$store.commit("setPostStatus", value);
      },
    },
    thinking: {
      get() {
        return this.$store.state.post.thinking;
      },
      set(value) {
        this.$store.commit("setPostThinking", value);
      },
    },
    sheet: {
      get() {
        return this.$store.state.post.sheet;
      },
      set(value) {
        this.$store.commit("setPostSheet", value);
      },
    },
    last_publish: {
      get() {
        return this.$store.state.post.last_publish;
      },
      set(value) {
        this.$store.commit("setPostLastPublish", value);
      },
    },
  },
};
